import { useIntl } from "react-intl";

import { ReactComponent as ShipIcon } from "assets/images/icons/Ship.svg";
import testIds from "constants/testIds";
import MenuItem from "./MenuItem";
import { IItemProps } from "../../interface/sidebar";

interface IShipperMenuItemsProps {
  handleCloseNav: () => void;
}

const GuestUserMenuItems = function ({ handleCloseNav }: IShipperMenuItemsProps) {
  const intl = useIntl();

  const navigationTop: IItemProps[] = [
    {
      eventKey: "5",
      id: "shipments",
      icon: <ShipIcon />,
      label: intl.formatMessage({
        id: "general.shipments",
        defaultMessage: "Shipments",
      }),
      parentUrl: "/shipments",
      to: "/shipments",
      enabled: true,
      testId: testIds.MENU_SHIPMENTS_BUTTON,
    },
  ];

  return (
    <div className="menu-item-center w-100 mt-3">
      {navigationTop.map((item) => (
        <MenuItem item={item} key={item.id} closeNav={handleCloseNav} testId={item.testId} />
      ))}
    </div>
  );
};

export default GuestUserMenuItems;
